import { useState, useCallback } from "react";

export const useDialog = () => {
  const [isOpen, setIsOpen] = useState(false);

  const onOpenChange = useCallback((value: boolean) => {
    setIsOpen(value);
  }, []);

  const onOpen = useCallback(() => {
    setIsOpen(true);
  }, []);

  const onClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  return { isOpen, onOpenChange, onOpen, onClose };
};
